import { useCallback } from 'react';
import Provider from 'react-redux/es/components/Provider';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';

// local imports
import store, { persistor } from './store';
import AppContext from './AppContext';
import { AuthService } from './services';
import { Request } from './utils';
import routes from './fuse-configs/routesConfig';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import FuseAuthorization from '@fuse/core/FuseAuthorization';

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()],
  insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName({ disableGlobal: true });

const App = () => {
  // initializing app
  const initAuth = useCallback(async () => {
    try {
      const token = await AuthService.init();
      !!token && Request.setAuthorization(token);
    } catch (e) {
      const message = `Auth manager cannot be initialized: ${JSON.stringify(e)}`;
      console.error(message);
      throw new Error(message);
    }
  }, []);

  const initApp = useCallback(async () => {
    try {
      await initAuth();
    } catch (e) {
      console.error('Error while initializing app: ', e);
    }
  }, [initAuth]);

  return (
    <AppContext.Provider
      value={{
        routes
      }}>
      <StylesProvider jss={jss} generateClassName={generateClassName}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor} onBeforeLift={initApp}>
            <Router>
              <FuseAuthorization>
                <FuseTheme>
                  <FuseLayout />
                </FuseTheme>
              </FuseAuthorization>
            </Router>
          </PersistGate>
        </Provider>
      </StylesProvider>
    </AppContext.Provider>
  );
};

export default App;
